export * from './constants';
export * from './middleware';
import rest from './rest';
export { rest };


// WEBPACK FOOTER //
// ./src/core/api/index.js